import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {PortConnectorUnitService} from '@catmodules/models/ports/services/port-connector-unit.service';
import {PortService} from '@catmodules/models/ports/services/port.service';
import {ProjectPortService} from "@catmodules/models/ports/services/project-port.service";

const publicComponents = [];

const imports = [
  CommonModule,
];
const declarations = [
  ...publicComponents,
];

const exportings = [...publicComponents];

const providers = [
  PortService,
  PortConnectorUnitService,
  ProjectPortService
];
const entryComponents = [...publicComponents];

@NgModule({
  declarations,
  entryComponents,
  exports: exportings,
  imports,
  providers,
})
export class PortModule {
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/ports/port.module.ts